import { Delete48Regular } from '@fluentui/react-icons'
import styles from './ClearChat.module.css'

interface Props {
    className?: string
    onClick: () => void
    disabled?: boolean
}

export const ClearChatButton = ({ className, disabled, onClick }: Props) => {
    return (
        <button
            className={`${styles.clearChatButton} ${className || ''}`}
            disabled={disabled}
            onClick={onClick}
            type="button"
        >
            <Delete48Regular />
        </button>
    )
}
